(function () {
  if (window.__bikezoneAnnouncementCustomLoaded) return;
  window.__bikezoneAnnouncementCustomLoaded = true;

  function init(root) {
    const slides = root.querySelectorAll(".announcement-slider__slide");
    if (!slides || slides.length <= 1) return;

    const prev = root.querySelector("[data-announcement-prev]");
    const next = root.querySelector("[data-announcement-next]");
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    let interval = parseInt(root.querySelector("[data-announcement-custom]")?.getAttribute("data-interval"), 10);
    if (!interval || interval < 1000) interval = 8000;

    let index = 0;
    let timer = null;

    function show(i) {
      slides[index].classList.remove("is-active");
      index = (i + slides.length) % slides.length;
      slides[index].classList.add("is-active");
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function start() {
      stop();
      if (prefersReduced) return;
      timer = window.setInterval(() => show(index + 1), interval);
    }

    // initial
    slides.forEach((s, i) => s.classList.toggle("is-active", i === 0));

    prev && prev.addEventListener("click", () => { show(index - 1); start(); });
    next && next.addEventListener("click", () => { show(index + 1); start(); });

    // pause on hover/focus
    root.addEventListener("mouseenter", stop);
    root.addEventListener("mouseleave", start);
    root.addEventListener("focusin", stop);
    root.addEventListener("focusout", start);

    start();
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".announcement-bar .slideshow-wrapper").forEach((wrapper) => {
      const slider = wrapper.querySelector("[data-announcement-custom]");
      if (slider) init(wrapper);
    });
  });

  // Theme editor re-render support
  document.addEventListener("shopify:section:load", function (e) {
    const wrapper = e.target.querySelector(".announcement-bar .slideshow-wrapper");
    if (!wrapper) return;
    const slider = wrapper.querySelector("[data-announcement-custom]");
    if (slider) init(wrapper);
  });
})();
